"use client";
import { Typography } from "antd";
import Image from "next/image";
import React from "react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { ContentType } from "../../contents/types";


interface SimpleCarouselProps {
  data: ContentType[];
  title?: string;
  showPagination?: boolean;
}

const SimpleCarousel = ({
  data,
  title,
  showPagination,
}: SimpleCarouselProps) => {
  const { Title } = Typography;
  return (
    <div className="h-auto mt-12 mb-3 gap-6 md:mt-16 md:mb-8 lg:mt-20 lg:mb-12">
      {title && (
        <Title level={2} className="H2 text-center">
          {title}
        </Title>
      )}
      <Swiper
        spaceBetween={8}
        centeredSlides={false}
        slidesPerView={2}
        breakpoints={{
          460: {
            slidesPerView: 2,
            spaceBetween: 0,
          },
          564: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
          992: {
            slidesPerView: 4,
            spaceBetween: 0,
          },
          1280: {
            slidesPerView: 5,
            spaceBetween: 0,
          },
          1536: {
            slidesPerView: 6,
            spaceBetween: 0,
          },
        }}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={showPagination ? { clickable: true } : undefined}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        {data.map((item) => (
          <SwiperSlide key={item.id}>
            <div className="flex items-center justify-center h-24 md:h-24 rounded-xl shadow-multiShadow gap-2">
              <Image
                src={item.logo}
                alt={item.name}
                width={100}
                height={100}
                className="w-full h-10"
                loading="lazy"
                onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                  e.currentTarget.src = "";
                }}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default SimpleCarousel;
